import { Tab } from '@mui/material';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader, QueryTabPanel, QueryTabs } from 'components';
import {
  RequisitesGroupList,
  RequisitesList,
  RequisitesTelegramAutomation,
} from 'features/requisites';
import { useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';

enum PayinArchiveTabs {
  Requisites = 'requisites',
  RequisitesGroups = 'requisites-groups',
  RequisitesTelegramAutomation = 'telegram-automation',
}

export const PayinArchivePage = () => {
  // TODO: move tkeys
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.archive',
  });
  const { isAdminOrTechOperator, isTrader } = useUser();

  return (
    <Fragment>
      <PageHeader title={t('title')} divider={false} />
      <QueryTabs tabsEnum={PayinArchiveTabs}>
        <Tab
          value={PayinArchiveTabs.Requisites}
          label={t(`tabs.${PayinArchiveTabs.Requisites}`)}
        />
        {(isAdminOrTechOperator || isTrader) && (
          <Tab
            value={PayinArchiveTabs.RequisitesGroups}
            label={t(`tabs.payin_requisites_groups`)}
          />
        )}
        {(isAdminOrTechOperator || isTrader) && (
          <Tab
            value={PayinArchiveTabs.RequisitesTelegramAutomation}
            label={t(`tabs.requisites_telegram_automation`)}
          />
        )}
      </QueryTabs>
      <QueryTabPanel value={PayinArchiveTabs.Requisites}>
        <RequisitesList archived />
      </QueryTabPanel>
      {(isAdminOrTechOperator || isTrader) && (
        <QueryTabPanel value={PayinArchiveTabs.RequisitesGroups}>
          <RequisitesGroupList archived />
        </QueryTabPanel>
      )}
      {(isAdminOrTechOperator || isTrader) && (
        <QueryTabPanel value={PayinArchiveTabs.RequisitesTelegramAutomation}>
          <RequisitesTelegramAutomation archived />
        </QueryTabPanel>
      )}
    </Fragment>
  );
};
